<div [style]="{ position: 'fixed', top: 0, left: 0, 'z-index': 0, visibility: 'none' }" inViewport
  (inViewportAction)="track($event)"></div>
